export type IconSizeToken = 'sm' | 'md' | 'lg';
export type IconSizeFullToken = `iconSize.${IconSizeToken}`;
export type BadgeSizeToken = 'badgeSize';
export type ModalWidthToken = 'modalWidth.sm' | 'modalWidth.md' | 'modalWidth.lg' | 'modalWidth.xl';
export type ModalOverlayBlurToken = 'modalOverlay.blur';
export type InputHeightToken = 'inputHeight';
export type DropdownMaxHeightToken = 'dropdownMaxHeight';
// TODO(design-token): validate with design team
export type DropdownMinWidthToken = 'dropdownMinWidth';
export type PopoverGutterToken = 'popoverGutter';
export type StatusIndicatorSizeToken = 'statusIndicatorSize';
export type TimelineToken =
  | 'timeline.minuteHeight'
  | 'timeline.headerHeight'
  | 'timeline.timestampsColumnWidth'
  | 'timeline.cardMargin';

export type StripesToken = 'stripes.default.width' | 'stripes.default.gap' | 'stripes.default.angle';

export type ScrollbarToken = 'scrollbar.size' | 'scrollbar.radius';

export type LayoutToken =
  | IconSizeFullToken
  | BadgeSizeToken
  | ModalWidthToken
  | ModalOverlayBlurToken
  | InputHeightToken
  | DropdownMaxHeightToken
  | DropdownMinWidthToken
  | PopoverGutterToken
  | StatusIndicatorSizeToken
  | TimelineToken
  | StripesToken
  | ScrollbarToken;

export const layout: Record<LayoutToken, number> = {
  // Icon Size
  'iconSize.lg': 24,
  'iconSize.md': 16,
  'iconSize.sm': 12,

  // Badge Size
  badgeSize: 24,

  // Modal
  'modalOverlay.blur': 4,
  'modalWidth.sm': 360,
  'modalWidth.md': 560,
  'modalWidth.lg': 680,
  'modalWidth.xl': 840,

  // Input Height
  inputHeight: 40,

  // Dropdown / Popover
  dropdownMaxHeight: 200,
  dropdownMinWidth: 200,
  popoverGutter: 4,

  // Status Indicator Size
  statusIndicatorSize: 12,

  // Timeline
  'timeline.minuteHeight': 7,
  'timeline.headerHeight': 56,
  'timeline.timestampsColumnWidth': 50,
  'timeline.cardMargin': 5,

  // Stripes
  'stripes.default.width': 20,
  'stripes.default.gap': 17,
  'stripes.default.angle': -40,

  // Scrollbar
  'scrollbar.size': 4,
  'scrollbar.radius': 8,
};
